import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { AttachMoney, LocalHospital, EventAvailable, HowToReg,DirectionsBus } from '@material-ui/icons';
import MenuItem from '@material-ui/core/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, } from 'reactstrap';

import AlertModal from '../../../../shared/components/Modal';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withStyles } from '@material-ui/core/styles';


const MedicalCheckbox = withStyles({
    root: {
      '&$checked': {
        color: '#4ce1b6',
      },
    },
    checked: {},
  })((props) => <Checkbox color="default" {...props} />);

const AddActivity = ({ budget, addActivitiesModal, closeActivitiesModal, opened, consultarPresupuestoPorFactibilidad, cantVisitBudget, visits, actividades }) => {
    const [openModal, setOpenModal] = React.useState(opened);

    //Atributos
    const [nombre, setNombre] = React.useState(null);
    const [costo, setCosto] = React.useState(0);
    const [costo_patrocinador, setCostoPatrocinador] = React.useState(0);
    const [precio, setPrecio] = React.useState(0);
    const [autoCompleteUsed, setAutocompleteUsed] = React.useState(false);

    const [overhead_check, setOverheadCheck] = React.useState(false);
    const [allVisits, setAllVisits] = React.useState(false);
    const [check_transporte, setCheckTransporte] = React.useState(false);


    //Alerta
    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");

    const checkedDays = [];

    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }

    const addActivityBudget = async () => {
        //Validaciones
        if (nombre == null) {
            alertModal(false, "El nombre es Requerido");
            return;
        }
        if (costo == null || costo <= 0) {
            alertModal(false, "El Costo debe ser mayor a 0");
            return;
        }
        if (costo_patrocinador == null || costo_patrocinador <= 0) {
            alertModal(false, "El Presupuesto debe ser mayor a 0");
            return;
        }
        if (precio == null || precio <= 0) {
            alertModal(false, "El Precio de Venta debe ser mayor a 0");
            return;
        }
        else {
            if (parseFloat(costo) > parseFloat(precio)) {
                alertModal(false, "El Precio de Venta debe ser mayor al Costo");
                return;
            }
        }

        if (overhead_check == null) {
            alertModal(false, "Debe elegir si manejara o no Overhead");//
            return;
        }

        let activityJSON = {
            nombre: nombre,
            costo: costo,
            costo_patrocinador: costo_patrocinador,
            precio: precio,
            overhead_check: overhead_check,
            id_factibilidad: budget.id_factibilidad,
            aplica_todos: checkedDays.length == visits.length ? true : false,
            daysVisit: checkedDays,
            check_transporte:check_transporte
        }

        fetch(`${process.env.REACT_APP_PUBLIC_URL}presupuesto/${budget.id_presupuesto}/agregar_actividad`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(activityJSON)
        }).then(response => response.json()).then(data => {

            if (data.success == true) {
                try {
                    consultarPresupuestoPorFactibilidad(budget.id_factibilidad);
                }
                catch (err) {
                    console.log(err);
                }
                closeActivitiesModal(true);
                alertModal(true, "Actividad Agregada correctamente");
            }
            else {
                alertModal(false, "Ha ocurrido un error agregando la actividad");
            }

        }).catch(err => {
            console.log(err);
            alertModal(false, "Ha ocurrido un error agregando la actividad");
        });

    }

    React.useEffect(() => {
        setOpenModal(opened);
    }, []);

    const handleAutocompleteName = (event, values) => {
        console.log("Usando Autocomplete");
        if (values != null) {
            setNombre(values.activity);
            setAutocompleteUsed(true);
        }
        else {
            setNombre(null);
            setAutocompleteUsed(false);
        }

    }

    const handleChangeName = (value) => {
        setAutocompleteUsed(false);
        if (autoCompleteUsed == false && value != null) {
            setNombre(value);
        }
        else {
            setAutocompleteUsed(false);
            setNombre(null);
        }
    }


    const handleChangeCheckbox = (value, check) => {
        if (check == true) {
            checkedDays.push(parseInt(value));
        }
        else {
            let position = checkedDays.indexOf(parseInt(value));
            if (position > -1) {
                checkedDays.splice(position, 1);
            }
        }
    }

    const CheckboxVisits = () => {
        let _row = [];

        try {
            if (allVisits == true && nombre != null && costo != null && costo_patrocinador != null & precio != null) {
                visits.map((item, i) => {
                    handleChangeCheckbox(i + 1, true)
                    _row.push(
                        <FormControlLabel
                            value={i + 1}
                            control={
                                <MedicalCheckbox
                                    defaultChecked={true}
                                    onChange={(event, check) => {
                                        handleChangeCheckbox(event.target.value, check)
                                    }}
                                    iconStyle={{fill: 'green'}} />
                            }
                            label={(i + 1).toString()}
                            labelPlacement={(i + 1).toString()}
                        />
                    )
                });
            }
            else if (allVisits == false && nombre != null && costo > 0 && costo_patrocinador > 0 & precio > 0) {
                visits.map((item, i) => {
                    _row.push(
                        <FormControlLabel
                            value={i + 1}
                            control={
                                <MedicalCheckbox
                                    onChange={(event, check) => {
                                        handleChangeCheckbox(event.target.value, check)
                                    }}
                                    iconStyle={{fill: 'green'}}
                                    
                                    
                                    />
                            }
                            label={(i + 1).toString()}
                            labelPlacement={(i + 1).toString()}
                        />
                    )
                });
            }
            else {
                visits.map((item, i) => {
                    _row.push(
                        <FormControlLabel
                            value={i + 1}
                            control={
                                <MedicalCheckbox
                                    onChange={(event, check) => {
                                        handleChangeCheckbox(event.target.value, check)
                                    }}
                                    iconStyle={{fill: 'green'}}
                                    />
                            }
                            disabled={true}
                            label={(i + 1).toString()}
                            labelPlacement={(i + 1).toString()}
                        />
                    )
                });
            }
        }
        catch (e) {

        }


        return (
            <FormGroup style={{ overflow: 'scroll', maxHeight: '100px' }} aria-label="position" row>
                {_row}
            </FormGroup>

        );
    }

    React.useEffect(() => {

    }, []);

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    setOpenModal(false);
                    closeActivitiesModal(false);
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>

                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Agregar Actividad</h5>
                        </div>

                        <Row>
                            <Col md={6}>
                                <Grid container spacing={1} alignItems="flex-end">
                                    <Grid item>
                                        <LocalHospital />
                                    </Grid>
                                    <Grid item>
                                        <Autocomplete
                                            id="input-with-icon-grid"
                                            options={actividades}
                                            getOptionLabel={(option) => option.activity ? option.activity : ""}
                                            debug
                                            noOptionsText="No hay opciones de Actividades"
                                            value={actividades}
                                            onChange={handleAutocompleteName}
                                            freeSolo={true}
                                            renderInput={(params) => (

                                                <TextField
                                                    onChange={(event) => handleChangeName(event.target.value)}
                                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                                    className="medical-material-form__field"
                                                    {...params} label="Actividad"
                                                    InputLabelProps={{
                                                        style: { color: '#646777' }
                                                    }}
                                                />
                                            )}
                                        />

                                    </Grid>
                                </Grid>
                            </Col>
                            <Col md={6}>
                                <Grid container spacing={1} alignItems="flex-end">
                                    <Grid item>
                                        <AttachMoney />
                                    </Grid>
                                    <Grid item>
                                        <TextField
                                            onChange={(e) => {
                                                setCosto(e.target.value);
                                            }}
                                            style={{ minWidth: '300px', maxWidth: '100%' }}
                                            id="input-with-icon-grid"
                                            type="number"
                                            label="Costo"
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                style: { color: '#646777' }
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Col>
                            <Col md={6}>
                                <Grid container spacing={1} alignItems="flex-end">
                                    <Grid item>
                                        <AttachMoney />
                                    </Grid>
                                    <Grid item>
                                        <TextField
                                            onChange={(e) => {
                                                setCostoPatrocinador(e.target.value);
                                            }}
                                            type="number"
                                            style={{ minWidth: '300px', maxWidth: '100%' }}
                                            id="input-with-icon-grid"
                                            label="Propuesta del Patrocinador"
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                style: { color: '#646777' }
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Col>
                            <Col md={6}>
                                <Grid container spacing={1} alignItems="flex-end">
                                    <Grid item>
                                        <AttachMoney />
                                    </Grid>
                                    <Grid item>
                                        <TextField
                                            onChange={(e) => {
                                                setPrecio(e.target.value);
                                            }}
                                            type="number"
                                            style={{ minWidth: '300px', maxWidth: '100%' }}
                                            id="input-with-icon-grid"
                                            label="Precio"
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                style: { color: '#646777' }
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Col>
                            <Col md={4}>
                                <Grid container spacing={1} alignItems="flex-end">
                                    <Grid item>
                                        <AttachMoney />
                                    </Grid>
                                    <Grid item>
                                        <TextField
                                            id="standard-select-overhead"
                                            select
                                            label=" "
                                            helperText="Seleccione si la maneja Overhead"
                                            value={overhead_check}

                                            onChange={(event) => {
                                                setOverheadCheck(event.target.value);
                                            }}

                                            style={{ minWidth: '200px', maxWidth: '100%' }}

                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                style: { color: '#646777' }
                                            }}
                                        >
                                            <MenuItem key={0} value={true}>
                                                SI
                                            </MenuItem>
                                            <MenuItem key={1} value={false}>
                                                NO
                                            </MenuItem>
                                        </TextField>
                                    </Grid>
                                </Grid>
                            </Col>
                           
                            <Col md={4}>
                                <Grid container spacing={1} alignItems="flex-end">
                                    <Grid item>
                                        <DirectionsBus />
                                    </Grid>
                                    <Grid item>
                                        <TextField
                                            id="standard-select-maneja_todos"
                                            select
                                            label=" "
                                            helperText="Es transporte o refrigerio"
                                            value={check_transporte}

                                            onChange={(event) => {
                                                setCheckTransporte(event.target.value);
                                            }}

                                            style={{ minWidth: '200px', maxWidth: '100%' }}
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                style: { color: '#646777' }
                                            }}
                                        >
                                            <MenuItem key={0} value={true}>
                                                SI
                                            </MenuItem>
                                            <MenuItem key={1} value={false}>
                                                NO
                                            </MenuItem>
                                        </TextField>
                                    </Grid>
                                </Grid>
                            </Col>
                            <Col md={4}>
                                <Grid container spacing={1} alignItems="flex-end">
                                    <Grid item>
                                        <EventAvailable />
                                    </Grid>
                                    <Grid item>
                                        <TextField
                                            id="standard-select-maneja_todos"
                                            select
                                            label=" "
                                            helperText="Es para todas las visitas?"
                                            value={allVisits}

                                            onChange={(event) => {
                                                setAllVisits(event.target.value);
                                            }}

                                            style={{ minWidth: '200px', maxWidth: '100%' }}
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                style: { color: '#646777' }
                                            }}
                                        >
                                            <MenuItem key={0} value={true}>
                                                SI
                                            </MenuItem>
                                            <MenuItem key={1} value={false}>
                                                NO
                                            </MenuItem>
                                        </TextField>
                                    </Grid>
                                </Grid>
                            </Col>
                        </Row>

                        <Container>
                            <CheckboxVisits />



                        </Container>

                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                addActivityBudget();
                            }}
                        >
                            Crear
                        </Button>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                setOpenModal(false);
                                closeActivitiesModal(false);
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => setAlerShowModal(false)}
                toggle={() => setAlerShowModal(false)}
            />
        </div>
    );
};
export default AddActivity;
